import { createContext, useContext, type ReactNode } from "react";
import type { ReportsApi } from "./reports-api";
const Context = createContext<ReportsApi | null>(null);
export function ReportsApiProvider({
  value,
  children,
}: {
  value: ReportsApi;
  children: ReactNode;
}) {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
export function useReportsApi(): ReportsApi {
  const value = useContext(Context);
  if (!value) throw new Error("ReportsApiProvider ausente");
  return value;
}
export function useOptionalReportsApi(): ReportsApi | null {
  return useContext(Context);
}
